var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    { staticClass: "navbar top-nav sticky-top border-bottom bg-white" },
    [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row w-100" }, [
          _c(
            "div",
            { staticClass: "col-3 d-flex" },
            [
              _c(
                "button",
                {
                  staticClass: "text-muted btn p-0 border-0 bg-transparent",
                  attrs: {
                    type: "button",
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    title: _vm.$t("Back"),
                    disabled: _vm.backLoading,
                  },
                  on: {
                    click: _vm.goBack,
                    mouseover: _vm.showTooltip,
                    mouseleave: _vm.hideTooltip,
                  },
                },
                [
                  !_vm.backLoading
                    ? _c("i", { staticClass: "fas fa-chevron-circle-left" })
                    : _c("i", { staticClass: "fas fa-spinner fa-spin" }),
                ]
              ),
              _vm._v(" "),
              _vm.show("sidebarToggle")
                ? _c(
                    "a",
                    {
                      staticClass: "text-muted ms-auto d-none",
                      attrs: {
                        href: "#",
                        "data-bs-toggle": "tooltip",
                        "data-bs-placement": "top",
                        title: _vm.$t("Toggle lecture list"),
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.setSideBarLeft("lectureList")
                        },
                        mouseover: _vm.showTooltip,
                        mouseleave: _vm.hideTooltip,
                      },
                    },
                    [_c("i", { staticClass: "fas fa-list" })]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("OffcanvasLectureList"),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col d-flex" }, [
            _c(
              "div",
              { staticClass: "d-none d-lg-block" },
              [
                _vm.previous
                  ? _c(
                      "router-link",
                      {
                        staticClass: "nav-link py-0 text-muted",
                        attrs: {
                          to: {
                            name: "lecture",
                            params: {
                              course: _vm.$route.params.course,
                              lecture: _vm.previous.id,
                            },
                          },
                        },
                      },
                      [_c("i", { staticClass: "fas fa-backward" })]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _vm.lecture && _vm.isAuthenticated
              ? _c(
                  "div",
                  { staticClass: "d-flex mx-auto" },
                  [
                    _c(
                      "a",
                      {
                        staticClass:
                          "nav-link py-0 text-muted d-none d-md-block mx-2",
                        attrs: {
                          href: "#",
                          "data-bs-toggle": "tooltip",
                          "data-bs-placement": "top",
                          title: _vm.$t("Notes"),
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.setUtilityTab("notes")
                          },
                          mouseover: _vm.showTooltip,
                          mouseleave: _vm.hideTooltip,
                        },
                      },
                      [_c("i", { staticClass: "far fa-sticky-note" })]
                    ),
                    _vm._v(" "),
                    _c("Star", {
                      staticClass: "mx-2",
                      attrs: { lecture: _vm.lecture },
                    }),
                    _vm._v(" "),
                    _c("AutoplayAudio", {
                      staticClass: "nav-link py-0 text-muted mx-2",
                    }),
                    _vm._v(" "),
                    _c("Autoplay", {
                      staticClass: "nav-link py-0 text-muted mx-2",
                    }),
                  ],
                  1
                )
              : _c("div", { staticClass: "mx-auto" }),
            _vm._v(" "),
            _vm.isAuthenticated
              ? _c("div", { staticClass: "me-4 small" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-lg-sm py-0",
                      attrs: {
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#reviewModal",
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "far fa-comment-dots d-lg-none text-muted",
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "d-none d-lg-inline" }, [
                        _vm._v(_vm._s(_vm._f("translate")("Leave a review"))),
                      ]),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.show("CompleteAndContinue")
              ? _c(
                  "div",
                  {},
                  [_c("CompleteAndContinue", { staticClass: "nav-link py-0" })],
                  1
                )
              : _vm._e(),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }